import gql from 'graphql-tag';

export const newsPostQuery = gql`
  query getNewsPost($slug: ID!) {
    news(id: $slug, idType: SLUG) {
      content
      date
      excerpt
      featuredImage {
        node {
          altText
          description
          mediaDetails {
            height
            width
          }
          sourceUrl
        }
      }
      featuredImageWidth
      imageSrcset
      title
    }
  }
`;
